import { type ReactNode, useMemo, useState } from 'react';

import { ViewBranchContext } from './ViewBranchContext';

/**
 * 「他人の目線」で翻訳を閲覧するための状態を保持する。viewBranch が null の間は
 * 自分のブランチを編集する通常モード、他者の `translations/*` ブランチを選ぶと read-only 閲覧。
 *
 * 状態はメモリ上のみ (リロードで自分のブランチに戻る)。書き込み系 API は常にログイン
 * ユーザー自身のブランチに固定されているため、閲覧中に誤って他者ブランチへ書き込むことはない。
 */
export const ViewBranchProvider = ({ children }: { children: ReactNode }) => {
  const [viewBranch, setViewBranch] = useState<string | null>(null);
  const value = useMemo(
    () => ({ viewBranch, setViewBranch, isReadOnly: viewBranch !== null }),
    [viewBranch],
  );
  return <ViewBranchContext.Provider value={value}>{children}</ViewBranchContext.Provider>;
};
